import { PencilIcon } from '@grupoboticario/flora-react-icons';
import {
  CardInfo,
  CardInfoFieldWrapper,
  CardInfoField,
} from '../../sharedStyles';

import { CardInfoTitleSummary, EditButton, CardInfoFields } from '../styles';

interface ICardSummary {
  editStep?: any;
  stateClaim: any;
}

export const Card03 = ({ editStep, stateClaim }: ICardSummary): JSX.Element => {
  return (
    <CardInfo>
      <CardInfoTitleSummary>
        Endereço da ocorrência
        {editStep && (
          <EditButton
            size="small"
            has="iconLeft"
            icon={<PencilIcon />}
            onClick={() => editStep(3)}
          >
            Editar
          </EditButton>
        )}
      </CardInfoTitleSummary>
      <CardInfoFields>
        <CardInfoFieldWrapper>
          <CardInfoField flex={4}>
            <span>CEP:</span>
            <p>{stateClaim.step.step1?.lojas?.data.address.zipCode || '-'}</p>
          </CardInfoField>
          <CardInfoField flex={2}>
            <span>Estado:</span>
            <p>{stateClaim.step.step1?.lojas?.data.address.uf || '-'}</p>
          </CardInfoField>
          <CardInfoField flex={3}>
            <span>Cidade:</span>
            <p>{stateClaim.step.step1?.lojas?.data.address.city || '-'}</p>
          </CardInfoField>
        </CardInfoFieldWrapper>
        <CardInfoFieldWrapper>
          <CardInfoField flex={4}>
            <span>Logradouro:</span>
            <p>
              {stateClaim.step.step1?.lojas?.data.address.streetName || '-'}
            </p>
          </CardInfoField>
          <CardInfoField flex={2}>
            <span>Número:</span>
            <p>{stateClaim.step.step1?.lojas?.data.address.number || '-'}</p>
          </CardInfoField>
          <CardInfoField flex={3}>
            <span>Complemento:</span>
            <p>
              {stateClaim.step.step1?.lojas?.data.address.complement || '-'}
            </p>
          </CardInfoField>
        </CardInfoFieldWrapper>
        <hr />
        <span className="singleLine">Observações:</span>
        <p className="singleLine">{stateClaim.step.step3?.comments || '-'}</p>
      </CardInfoFields>
    </CardInfo>
  );
};
